import axios, { AxiosError, AxiosResponse } from "axios";

import { DAO_SESHAT } from "@/api/DAO";
import {
  CMS_URL,
  CMS_URL_URL,
  USER_CMS_MANAGEMENT_URL
} from "@/api/URL-constants";

import {
  Cms,
  CmsResponse,
  CmsUrl,
  CmsUrlResponse,
  UserCmsManagementUpdatePayload
} from "@/models/api/cms.model";

const getCms = () => {
  return DAO_SESHAT()
    .get(`${CMS_URL}`)
    .then((response: AxiosResponse<CmsResponse>): Cms[] => {
      return response.data.data;
    });
};

const getCmsUrl = (cmsId: number) => {
  return DAO_SESHAT()
    .get(`${CMS_URL_URL}/${cmsId}`)
    .then((response: AxiosResponse<CmsUrlResponse>): CmsUrl => {
      return response.data.data;
    })
    .catch((error: Error | AxiosError) => {
      if (axios.isAxiosError(error) && error.response) {
        throw error.response.data.message;
      } else {
        throw error.message;
      }
    });
};

const updateUserCmsManagement = (
  payload: UserCmsManagementUpdatePayload
): Promise<AxiosResponse> => {
  return DAO_SESHAT().put(USER_CMS_MANAGEMENT_URL, payload);
};

const removeUserCms = (
  userId: number,
  cmsId: number
): Promise<AxiosResponse> => {
  return DAO_SESHAT().delete(`${USER_CMS_MANAGEMENT_URL}/${userId}/${cmsId}`);
};

export { getCms, getCmsUrl, updateUserCmsManagement, removeUserCms };
